import { combineReducers } from "redux";
import * as ActionTypes from "../../actions";
import status from "./status";
import afipActivityApiCalls from "./afipActivityApiCalls";
import aiUserApiCalls from "./aiUserApiCalls";
import authenticationApiCalls from "./authenticationApiCalls";
import balanceApiCalls from "./balanceApiCalls";
import balanceLineChartDatasetApiCalls from "./balanceLineChartDatasetApiCalls";
import bankAccountApiCalls from "./bankAccountApiCalls";
import bankAccountTypeApiCalls from "./bankAccountTypeApiCalls";
import bankApiCalls from "./bankApiCalls";
import bankHolidayApiCalls from "./bankHolidayApiCalls";
import bindTransactionApiCalls from "./bindTransactionApiCalls";
import bookmarkApiCalls from "./bookmarkApiCalls";
import bookmarkListItemApiCalls from "./bookmarkListItemApiCalls";
import boostApiCalls from "./boostApiCalls";
import boostBrokerCurrencyBalanceApiCalls from "./boostBrokerCurrencyBalanceApiCalls";
import boostListItemApiCalls from "./boostListItemApiCalls";
import brokerApiCalls from "./brokerApiCalls";
import brokerCurrencyBalanceApiCalls from "./brokerCurrencyBalanceApiCalls";
import brokerCurrencyGoalInvestmentItemUserBalanceApiCalls from "./brokerCurrencyGoalInvestmentItemUserBalanceApiCalls";
import brokerCurrencyGoalUserBalanceApiCalls from "./brokerCurrencyGoalUserBalanceApiCalls";
import brokerCurrencyInvestmentItemBalanceApiCalls from "./brokerCurrencyInvestmentItemBalanceApiCalls";
import brokerCurrencyInvestmentItemUserBalanceApiCalls from "./brokerCurrencyInvestmentItemUserBalanceApiCalls";
import brokerCurrencyUserBalanceApiCalls from "./brokerCurrencyUserBalanceApiCalls";
import brokerFollowerApiCalls from "./brokerFollowerApiCalls";
import brokerMentionListItemApiCalls from "./brokerMentionListItemApiCalls";
import brokerViewApiCalls from "./brokerViewApiCalls";
import cafciClaseApiCalls from "./cafciClaseApiCalls";
import cafciClaseViewApiCalls from "./cafciClaseViewApiCalls";
import cafciCarteraApiCalls from "./cafciCarteraApiCalls";
import cafciPrecioApiCalls from "./cafciPrecioApiCalls";
import campaignApiCalls from "./campaignApiCalls";
import countryApiCalls from "./countryApiCalls";
import currencyApiCalls from "./currencyApiCalls";
import currencyBalanceApiCalls from "./currencyBalanceApiCalls";
import currencyGoalInvestmentItemUserBalanceApiCalls from "./currencyGoalInvestmentItemUserBalanceApiCalls";
import currencyGoalUserBalanceApiCalls from "./currencyGoalUserBalanceApiCalls";
import currencyInvestmentItemUserBalanceApiCalls from "./currencyInvestmentItemUserBalanceApiCalls";
import currencyUserBalanceApiCalls from "./currencyUserBalanceApiCalls";
import currencyVariantInvestmentItemApiCalls from "./currencyVariantInvestmentItemApiCalls";
import distributionTabApiCalls from "./distributionTabApiCalls";
import documentApiCalls from "./documentApiCalls";
import documentTypeApiCalls from "./documentTypeApiCalls";
import employeeApiCalls from "./employeeApiCalls";
import eventListItemApiCalls from "./eventListItemApiCalls";
import eventReactionApiCalls from "./eventReactionApiCalls";
import externalBalanceApiCalls from "./externalBalanceApiCalls";
import genderApiCalls from "./genderApiCalls";
import goalApiCalls from "./goalApiCalls";
import goalFollowerApiCalls from "./goalFollowerApiCalls";
import goalMemberApiCalls from "./goalMemberApiCalls";
import goalMemberListItemApiCalls from "./goalMemberListItemApiCalls";
import goalMembersTabApiCalls from "./goalMembersTabApiCalls";
import goalMembersViewApiCalls from "./goalMembersViewApiCalls";
import goalMentionListItemApiCalls from "./goalMentionListItemApiCalls";
import goalTypeApiCalls from "./goalTypeApiCalls";
import goalViewApiCalls from "./goalViewApiCalls";
import groupApiCalls from "./groupApiCalls";
import hashtagApiCalls from "./hashtagApiCalls";
import hashtagFollowerApiCalls from "./hashtagFollowerApiCalls";
import hashtagMentionListItemApiCalls from "./hashtagMentionListItemApiCalls";
import hashtagViewApiCalls from "./hashtagViewApiCalls";
import incomeTypeApiCalls from "./incomeTypeApiCalls";
import industryApiCalls from "./industryApiCalls";
import invertirOnlinePriceApiCalls from "./invertirOnlinePriceApiCalls";
import invertirOnlineTitleApiCalls from "./invertirOnlineTitleApiCalls";
import invertirOnlineTitleViewApiCalls from "./invertirOnlineTitleViewApiCalls";
import investmentAccountApiCalls from "./investmentAccountApiCalls";
import investmentItemApiCalls from "./investmentItemApiCalls";
import investmentItemFollowerApiCalls from "./investmentItemFollowerApiCalls";
import investmentItemListItemApiCalls from "./investmentItemListItemApiCalls";
import investmentItemMentionListItemApiCalls from "./investmentItemMentionListItemApiCalls";
import investmentItemsViewApiCalls from "./investmentItemsViewApiCalls";
import investmentItemTypeApiCalls from "./investmentItemTypeApiCalls";
import investmentPartyApiCalls from "./investmentPartyApiCalls";
import investmentPlanApiCalls from "./investmentPlanApiCalls";
import investmentPlanPreferenceApiCalls from "./investmentPlanPreferenceApiCalls";
import ivaTaxpayerTypeApiCalls from "./ivaTaxpayerTypeApiCalls";
import languageApiCalls from "./languageApiCalls";
import maritalStatusApiCalls from "./maritalStatusApiCalls";
import mediaApiCalls from "./mediaApiCalls";
import myBrokersDashboardStatsApiCalls from "./myBrokersDashboardStatsApiCalls";
import messageApiCalls from "./messageApiCalls";
import notificationApiCalls from "./notificationApiCalls";
import notificationListItemApiCalls from "./notificationListItemApiCalls";
import notificationTabApiCalls from "./notificationTabApiCalls";
import numericConventionApiCalls from "./numericConventionApiCalls";
import operationApiCalls from "./operationApiCalls";
import participantApiCalls from "./participantApiCalls";
import personApiCalls from "./personApiCalls";
import pickApiCalls from "./pickApiCalls";
import postListItemApiCalls from "./postListItemApiCalls";
import postApiCalls from "./postApiCalls";
import postReactionApiCalls from "./postReactionApiCalls";
import postReactionListItemApiCalls from "./postReactionListItemApiCalls";
import priceApiCalls from "./priceApiCalls";
import priceForecastApiCalls from "./priceForecastApiCalls";
import priceLineChartDatasetApiCalls from "./priceLineChartDatasetApiCalls";
import questionApiCalls from "./questionApiCalls";
import quoteApiCalls from "./quoteApiCalls";
import riskProfileApiCalls from "./riskProfileApiCalls";
import sentimentTypeApiCalls from "./sentimentTypeApiCalls";
import timeZoneApiCalls from "./timeZoneApiCalls";
import transactionApiCalls from "./transactionApiCalls";
import uiPreferencesApiCalls from "./uiPreferencesApiCalls";
import userApiCalls from "./userApiCalls";
import userFollowerApiCalls from "./userFollowerApiCalls";
import userFollowerListItemApiCalls from "./userFollowerListItemApiCalls";
import userMentionListItemApiCalls from "./userMentionListItemApiCalls";
import usersViewApiCalls from "./usersViewApiCalls";
import validateDocumentApiCalls from "./validateDocumentApiCalls";
import walletViewApiCalls from "./walletViewApiCalls";
import watchlistItemApiCalls from "./watchlistItemApiCalls";
import watchlistItemListItemApiCalls from "./watchlistItemListItemApiCalls";
import wireTransferApiCalls from "./wireTransferApiCalls";
import workingStatusApiCalls from "./workingStatusApiCalls";
import wsMessageApiCalls from "./wsMessageApiCalls";

//Updates the status apiCalls data for different api call.
var someReducers = {
  signup: status({
    mapActionToKey: function mapActionToKey() {
      return "undefined";
    },
    types: [ActionTypes.POST_SIGNUP_REQUEST, ActionTypes.POST_SIGNUP_SUCCESS, ActionTypes.POST_SIGNUP_FAILURE, ActionTypes.RESET_POST_SIGNUP]
  }),
  contactUs: status({
    mapActionToKey: function mapActionToKey() {
      return "undefined";
    },
    types: [ActionTypes.POST_CONTACTUS_REQUEST, ActionTypes.POST_CONTACTUS_SUCCESS, ActionTypes.POST_CONTACTUS_FAILURE, ActionTypes.RESET_POST_CONTACTUS]
  }),
  logout: status({
    mapActionToKey: function mapActionToKey() {
      return "undefined";
    },
    types: [ActionTypes.LOGOUT_REQUEST, ActionTypes.LOGOUT_SUCCESS, ActionTypes.LOGOUT_FAILURE, ActionTypes.RESET_LOGOUT]
  }),
  forgotPassword: status({
    mapActionToKey: function mapActionToKey() {
      return "undefined";
    },
    types: [ActionTypes.FORGOTPASSWORD_REQUEST, ActionTypes.FORGOTPASSWORD_SUCCESS, ActionTypes.FORGOTPASSWORD_FAILURE, ActionTypes.RESET_FORGOTPASSWORD]
  }),
  changePassword: status({
    mapActionToKey: function mapActionToKey() {
      return "undefined";
    },
    types: [ActionTypes.CHANGEPASSWORD_REQUEST, ActionTypes.CHANGEPASSWORD_SUCCESS, ActionTypes.CHANGEPASSWORD_FAILURE, ActionTypes.RESET_CHANGEPASSWORD]
  }),
  register: status({
    mapActionToKey: function mapActionToKey() {
      return "undefined";
    },
    types: [ActionTypes.REGISTER_REQUEST, ActionTypes.REGISTER_SUCCESS, ActionTypes.REGISTER_FAILURE, ActionTypes.RESET_REGISTER]
  }),
  loadDashboardStats: status({
    mapActionToKey: function mapActionToKey() {
      return "undefined";
    },
    types: [ActionTypes.GET_DASHBOARDSTATS_REQUEST, ActionTypes.GET_DASHBOARDSTATS_SUCCESS, ActionTypes.GET_DASHBOARDSTATS_FAILURE, ActionTypes.RESET_GET_DASHBOARDSTATS]
  }),
  investmentParty: status({
    mapActionToKey: function mapActionToKey() {
      return "undefined";
    },
    types: [ActionTypes.POST_SHAREINVESTMENTPARTY_REQUEST, ActionTypes.POST_SHAREINVESTMENTPARTY_SUCCESS, ActionTypes.POST_SHAREINVESTMENTPARTY_FAILURE, ActionTypes.RESET_POST_SHAREINVESTMENTPARTY]
  }),
  reportPost: status({
    mapActionToKey: function mapActionToKey(action) {
      return action.postId.toString();
    },
    types: [ActionTypes.POST_REPORTPOST_REQUEST, ActionTypes.POST_REPORTPOST_SUCCESS, ActionTypes.POST_REPORTPOST_FAILURE, ActionTypes.RESET_POST_REPORTPOST]
  }),
  reportUser: status({
    mapActionToKey: function mapActionToKey(action) {
      return action.userId.toString().toString();
    },
    types: [ActionTypes.POST_REPORTUSER_REQUEST, ActionTypes.POST_REPORTUSER_SUCCESS, ActionTypes.POST_REPORTUSER_FAILURE, ActionTypes.RESET_POST_REPORTUSER]
  }),
  reportInvestmentItemDescription: status({
    mapActionToKey: function mapActionToKey(action) {
      return action.investmentItemId.toString();
    },
    types: [ActionTypes.POST_REPORTINVESTMENTITEMDESCRIPTION_REQUEST, ActionTypes.POST_REPORTINVESTMENTITEMDESCRIPTION_SUCCESS, ActionTypes.POST_REPORTINVESTMENTITEMDESCRIPTION_FAILURE, ActionTypes.RESET_POST_REPORTINVESTMENTITEMDESCRIPTION]
  }),
  reportBrokerDescription: status({
    mapActionToKey: function mapActionToKey(action) {
      return action.brokerId.toString();
    },
    types: [ActionTypes.POST_REPORTBROKERDESCRIPTION_REQUEST, ActionTypes.POST_REPORTBROKERDESCRIPTION_SUCCESS, ActionTypes.POST_REPORTBROKERDESCRIPTION_FAILURE, ActionTypes.RESET_POST_REPORTBROKERDESCRIPTION]
  }),
  postInvestmentItemDescription: status({
    mapActionToKey: function mapActionToKey(action) {
      return action.investmentItem.id.toString();
    },
    types: [ActionTypes.POST_INVESTMENTITEMDESCRIPTION_REQUEST, ActionTypes.POST_INVESTMENTITEMDESCRIPTION_SUCCESS, ActionTypes.POST_INVESTMENTITEMDESCRIPTION_FAILURE, ActionTypes.RESET_POST_INVESTMENTITEMDESCRIPTION]
  }),
  postBrokerDescription: status({
    mapActionToKey: function mapActionToKey(action) {
      return action.broker.id.toString();
    },
    types: [ActionTypes.POST_BROKERDESCRIPTION_REQUEST, ActionTypes.POST_BROKERDESCRIPTION_SUCCESS, ActionTypes.POST_BROKERDESCRIPTION_FAILURE, ActionTypes.RESET_POST_BROKERDESCRIPTION]
  }),
  enhancePostText: status({
    mapActionToKey: function mapActionToKey() {
      return "undefined";
    },
    types: [ActionTypes.POST_ENHANCEPOSTTEXT_REQUEST, ActionTypes.POST_ENHANCEPOSTTEXT_SUCCESS, ActionTypes.POST_ENHANCEPOSTTEXT_FAILURE, ActionTypes.RESET_POST_ENHANCEPOSTTEXT]
  }),
  spellcheckPostText: status({
    mapActionToKey: function mapActionToKey() {
      return "undefined";
    },
    types: [ActionTypes.POST_SPELLCHECKPOSTTEXT_REQUEST, ActionTypes.POST_SPELLCHECKPOSTTEXT_SUCCESS, ActionTypes.POST_SPELLCHECKPOSTTEXT_FAILURE, ActionTypes.RESET_POST_SPELLCHECKPOSTTEXT]
  })
};
var allReducers = Object.assign(someReducers, afipActivityApiCalls, aiUserApiCalls, authenticationApiCalls, balanceApiCalls, balanceLineChartDatasetApiCalls, bankAccountApiCalls, bankAccountTypeApiCalls, bankApiCalls, bankHolidayApiCalls, bindTransactionApiCalls, bookmarkApiCalls, bookmarkListItemApiCalls, boostApiCalls, boostBrokerCurrencyBalanceApiCalls, boostListItemApiCalls, brokerApiCalls, brokerCurrencyBalanceApiCalls, brokerCurrencyGoalInvestmentItemUserBalanceApiCalls, brokerCurrencyGoalUserBalanceApiCalls, brokerCurrencyInvestmentItemBalanceApiCalls, brokerCurrencyInvestmentItemUserBalanceApiCalls, brokerCurrencyUserBalanceApiCalls, brokerFollowerApiCalls, brokerMentionListItemApiCalls, brokerViewApiCalls, cafciClaseApiCalls, cafciClaseViewApiCalls, cafciCarteraApiCalls, cafciPrecioApiCalls, campaignApiCalls, countryApiCalls, currencyApiCalls, currencyBalanceApiCalls, currencyGoalInvestmentItemUserBalanceApiCalls, currencyGoalUserBalanceApiCalls, currencyInvestmentItemUserBalanceApiCalls, currencyUserBalanceApiCalls, currencyVariantInvestmentItemApiCalls, distributionTabApiCalls, documentApiCalls, documentTypeApiCalls, employeeApiCalls, eventListItemApiCalls, eventReactionApiCalls, externalBalanceApiCalls, genderApiCalls, goalApiCalls, goalFollowerApiCalls, goalMemberApiCalls, goalMemberListItemApiCalls, goalMembersTabApiCalls, goalMembersViewApiCalls, goalMentionListItemApiCalls, goalTypeApiCalls, goalViewApiCalls, groupApiCalls, hashtagApiCalls, hashtagFollowerApiCalls, hashtagMentionListItemApiCalls, hashtagViewApiCalls, incomeTypeApiCalls, industryApiCalls, invertirOnlinePriceApiCalls, invertirOnlineTitleApiCalls, invertirOnlineTitleViewApiCalls, investmentAccountApiCalls, investmentItemApiCalls, investmentItemFollowerApiCalls, investmentItemMentionListItemApiCalls, investmentItemsViewApiCalls, investmentItemTypeApiCalls, investmentItemListItemApiCalls, investmentPartyApiCalls, investmentPlanApiCalls, investmentPlanPreferenceApiCalls, ivaTaxpayerTypeApiCalls, languageApiCalls, maritalStatusApiCalls, mediaApiCalls, myBrokersDashboardStatsApiCalls, messageApiCalls, notificationApiCalls, notificationListItemApiCalls, notificationTabApiCalls, numericConventionApiCalls, operationApiCalls, participantApiCalls, personApiCalls, pickApiCalls, postListItemApiCalls, postApiCalls, postReactionApiCalls, postReactionListItemApiCalls, priceApiCalls, priceForecastApiCalls, priceLineChartDatasetApiCalls, questionApiCalls, quoteApiCalls, riskProfileApiCalls, sentimentTypeApiCalls, timeZoneApiCalls, transactionApiCalls, uiPreferencesApiCalls, userApiCalls, userFollowerApiCalls, userFollowerListItemApiCalls, userMentionListItemApiCalls, usersViewApiCalls, validateDocumentApiCalls, walletViewApiCalls, watchlistItemApiCalls, watchlistItemListItemApiCalls, wireTransferApiCalls, workingStatusApiCalls, wsMessageApiCalls);
var apiCalls = combineReducers(allReducers);
export default apiCalls;